import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
	loging: false,
}

const mutations = {
	SET_LOGING: (state, loging) => {
		state.loging = loging
	}
}

const actions = {
	openLogin({
		commit
	}, data) {
		commit('SET_LOGING', data.loging)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}